// ==============================|| UNCOUPLE ICON ||============================== //

const UnCoupleIcon = ({ color = '#000', width = 24, className = '' }) => {
  const commonStyle = {
    fill: color,
    strokeWidth: '0px',
  };

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 41.1 38.8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.3,29h-1.3c-.5,0-.8.4-.8.8v.2c0,.5.4.8.8.8h1.3v-1.9h0Z"
        style={commonStyle}
      />
      <path
        d="M31.2,23.3c-1.3,0-2.5-.2-3.7-.7-1.1-.5-2.1-1.2-3-2-0.8-.8-1.5-1.8-2-3-0.5-1.1-0.7-2.4-0.7-3.7s0.2-2.5,0.7-3.6c0.5-1.1,1.2-2.1,2-3,0.8-0.8,1.8-1.5,3-2,1.1-0.5,2.4-0.7,3.7-0.7s2.5,0.2,3.7,0.7c1.1,0.5,2.1,1.2,3,2,0.8,0.8,1.5,1.8,2,3,0.5,1.1,0.7,2.4,0.7,3.6s-0.2,2.5-0.7,3.7c-0.5,1.1-1.2,2.1-2,3-0.8,0.8-1.8,1.5-3,2-1.1,0.5-2.4,0.7-3.7,0.7ZM31.2,21.2c0.8,0,1.6-0.1,2.3-0.4,0.7-0.2,1.4-0.6,2-1.1l-10.2-10.2c-0.5,0.6-0.8,1.3-1.1,2.1-0.2,0.7-0.4,1.5-0.4,2.3,0,2,0.7,3.8,2.1,5.2s3.1,2.1,5.2,2.1h0.1ZM37,18.2c0.5-0.6,0.8-1.3,1.1-2.1,0.2-0.7,0.4-1.5,0.4-2.3,0-2-0.7-3.7-2.1-5.2-1.4-1.4-3.1-2.1-5.2-2.1s-1.6,0-2.3,0.4c-0.7,0.2-1.4,0.6-2,1.1l10.2,10.2h-0.1Z"
        style={commonStyle}
      />
      <path
        d="M11.2,31.3c-0.9,0-1.7,0.8-1.7,1.7s0.7,1.7,1.7,1.7,1.7-0.8,1.7-1.7-0.8-1.7-1.7-1.7Z"
        style={commonStyle}
      />
      <path
        d="M26.2,31.3c-0.9,0-1.7,0.8-1.7,1.7s0.7,1.7,1.7,1.7,1.7-0.8,1.7-1.7-0.8-1.7-1.7-1.7Z"
        style={commonStyle}
      />
      <path
        d="M32,25.9c-1.7,0-3.4-0.3-4.9-1-0.3-0.1-0.5-0.3-0.8-0.4H7.2v1.7H2c-0.5,0-0.8,0.4-0.8,0.8v5.2c0,0.5,0.4,0.8,0.8,0.8h2.9c0-4,3.2-6.5,6.4-6.5s6.4,2.9,6.4,6.4h2.1c0.1-4,3.1-6.4,6.4-6.4s6.4,2.9,6.4,6.4h6.9v-6.9h-1.1v-1.7h-0.7c-0.3,0.1-0.5,0.3-0.8,0.4-1.5,0.7-3.1,1-4.9,1Z"
        style={commonStyle}
      />
      <path
        d="M26.2,27.5c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5,5.5-2.5,5.5-5.5-2.5-5.5-5.5-5.5ZM26.2,34.7c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7,1.7,0.8,1.7,1.7-0.8,1.7-1.7,1.7Z"
        style={commonStyle}
      />
      <path
        d="M11.2,27.5c-3,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5,5.5-2.5,5.5-5.5-2.5-5.5-5.5-5.5ZM11.2,34.7c-1,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7,1.7,0.8,1.7,1.7-0.8,1.7-1.7,1.7Z"
        style={commonStyle}
      />
      <circle
        cx="18.3"
        cy="20.8"
        r="2.7"
        style={commonStyle}
      />
      <path
        d="M19.8,16.1L3.8,11.4c-0.5-0.2-1.1,0.1-1.2,0.7v0.2c-0.2,0.5,0,1.1,0.6,1.2l17.5,5.1c0-0.1-0.1-0.3-0.2-0.4-0.3-0.7-0.5-1.4-0.7-2.1Z"
        style={commonStyle}
      />
    </svg>
  );
};

export default UnCoupleIcon;
